const LanguageTypeEnum = {
    zh:0,
    en:1,
    zhen:2,
}
export default LanguageTypeEnum;
